module.exports = __WEBPACK_EXTERNAL_MODULE__jupyter_widgets_base__;